module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-2 control-label"
  }, [_vm._t("label", [_vm._v("\n      " + _vm._s(_vm.label) + "\n      ")]), _vm._v(" "), (_vm.showRequire === true) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("必須")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-10"
  }, [_vm._t("text", [(_vm.readonly) ? _c('input', {
    staticClass: "form-control",
    attrs: {
      "readonly": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.val
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.readonly) ? _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": _vm.maxLength
    },
    domProps: {
      "value": _vm.val
    },
    on: {
      "input": _vm.onInput
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("message")])], 2)]), _vm._v(" "), _vm._t("line", [_c('line-dashed')])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b09a6c9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/TextGroup.vue
// module id = 442
// module chunks = 1